import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { GetSessionStorageData } from "../helper";
import { TOKENS, ROUTES } from "../Constants/Constants";

const PrivateRoutesCheck = () => {
  const token = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const currentToken = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
      if (currentToken) {
        // If we're on a protected route and try to go back
        window.history.pushState(null, '', location.pathname);
      } else {
        navigate(ROUTES.LOGIN);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, navigate]);

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return <Layout />;
};

export default PrivateRoutesCheck;